import { useEffect, useState } from 'react';
import { ChevronDown, Menu, X } from 'lucide-react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { Brand } from './Brand';

const legalLinks = [
  ['Terms', '/terms'],
  ['Privacy', '/privacy'],
  ['Fares & refunds', '/fares-cancellations-refunds'],
  ['Captain terms', '/captain-terms'],
  ['Courier items', '/courier-prohibited-items'],
  ['Account deletion', '/account-deletion'],
];

export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

export function Layout() {
  const [open, setOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
    setServicesOpen(false);
  }, [location.pathname]);

  return (
    <div className="site-shell">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <div className="announcement">
        <div className="container announcement__inner">
          <span><i aria-hidden="true" /> Built for Pakistan · Availability varies by city</span>
          <Link to="/captains">Captain registration preview <span aria-hidden="true">→</span></Link>
        </div>
      </div>

      <header className="site-header">
        <div className="container nav-wrap">
          <Brand />
          <button
            className="nav-toggle"
            type="button"
            aria-label={open ? 'Close navigation' : 'Open navigation'}
            aria-expanded={open}
            onClick={() => setOpen((value) => !value)}
          >
            {open ? <X /> : <Menu />}
          </button>

          <nav className={`main-nav ${open ? 'main-nav--open' : ''}`} aria-label="Primary navigation">
            <NavLink to="/" end>Home</NavLink>
            <div className={`nav-dropdown ${servicesOpen ? 'nav-dropdown--open' : ''}`}>
              <button
                type="button"
                onClick={() => setServicesOpen((value) => !value)}
                aria-expanded={servicesOpen}
              >
                Services <ChevronDown size={16} />
              </button>
              <div className="nav-dropdown__menu">
                <NavLink to="/services">All services <span>Overview</span></NavLink>
                <NavLink to="/services/rides">Rides <span>City and intercity</span></NavLink>
                <NavLink to="/services/courier">Courier <span>Within-city delivery</span></NavLink>
              </div>
            </div>
            <NavLink to="/captains">Captains</NavLink>
            <NavLink to="/safety">Safety</NavLink>
            <NavLink to="/support">Support</NavLink>
            <Link className="button button--small button--primary nav-cta" to="/services/rides">
              Plan a ride
            </Link>
          </nav>
        </div>
      </header>

      <main id="main-content">
        <Outlet />
      </main>

      <footer className="site-footer">
        <div className="container footer-grid">
          <div className="footer-brand">
            <Brand inverse />
            <p>
              A locally built mobility and courier platform designed around clear choices,
              responsible operations and trusted connections.
            </p>
            <span className="footer-badge">Pakistan-wide platform · Locally authorized service</span>
          </div>
          <div>
            <h2>Explore</h2>
            <Link to="/services/rides">City & intercity rides</Link>
            <Link to="/services/courier">Courier</Link>
            <Link to="/captains">Become a Captain</Link>
            <Link to="/safety">Safety centre</Link>
          </div>
          <div>
            <h2>Help</h2>
            <Link to="/support">Support</Link>
            <Link to="/complaints">Complaints policy</Link>
            <a href="mailto:support@sawwari.com">support@sawwari.com</a>
            <span>Emergency: call 15</span>
          </div>
          <div>
            <h2>Legal</h2>
            {legalLinks.map(([label, path]) => (
              <Link key={path} to={path}>{label}</Link>
            ))}
          </div>
        </div>
        <div className="container footer-bottom">
          <span>© 2026 Sawwari. A ZND Ventures LLP platform.</span>
          <span>Public policies v1.0 · Effective 15 July 2026</span>
        </div>
      </footer>
    </div>
  );
}
